export const Squiggle = ({ className = "", color = "#FF5A5F" }) => (
  <svg
    className={className}
    width="180"
    height="14"
    viewBox="0 0 180 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M2 8 C 20 -2, 40 14, 60 6 S 100 -2, 120 8 S 160 14, 178 6"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const Star = ({ className = "", color = "#FFB400", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 2 L14.2 8.6 L21 9 L15.6 13.2 L17.5 20 L12 16 L6.5 20 L8.4 13.2 L3 9 L9.8 8.6 Z"
      fill={color}
      stroke="#1E1E24"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
